import { useGetPayloadData } from '../../components/ClientAutoSaveOnBlur/hooks/useGetPayloadData';
import { setBEFieldError } from '@/utils/setBEFieldError';
import { useFormContext } from 'react-hook-form';
import type { ErrorResponse } from '@/types/apiTypes';
import { useUpdateClientPreferences } from '../useUpdateClientPreferences';
import type { CreateClientFormData } from '@/types/clientsApiTypes';
import { getTravelPreferencesRelatedData } from './utils/getTravelPreferencesRelatedData';
import type { RelatedDataKeys } from './types';

export const useUpdateTravelPreferencesWithRelatedData = () => {
  const { setError, watch } = useFormContext<CreateClientFormData>();
  const { mutateAsync: updatePreferencesMutation } = useUpdateClientPreferences();
  const { getPassengerId } = useGetPayloadData();

  const updateTravelPreferencesWithRelatedData = async (
    fieldKey: RelatedDataKeys,
    fieldName: string,
    fieldValue: unknown,
    fullPath: string,
    onSuccess?: () => void
  ) => {
    const passengerId = getPassengerId(fullPath);
    try {
      const payloadData = getTravelPreferencesRelatedData(
        fieldKey,
        fieldName,
        fieldValue,
        watch() as CreateClientFormData,
        fullPath
      );
      return await updatePreferencesMutation(
        {
          data: payloadData,
          clientId: passengerId,
        },
        {
          onSuccess: () => {
            onSuccess?.();
          },
        }
      );
    } catch (error) {
      setBEFieldError(error as ErrorResponse<unknown>, setError);
      return undefined;
    }
  };

  return { updateTravelPreferencesWithRelatedData };
};
